
import { useNavigate, useLocation } from 'react-router-dom';
import DashBoardSelect from 'components/Dropdown/dashboardSelect';
import { Menu, MenuDivider, MenuItem } from '@szhsin/react-menu';
import RoleSelect from 'components/Dropdown/RoleSelect';
import { useDispatch, useSelector } from 'react-redux';
import { setIsNotificationModalOpen } from "../../slices/chat/reducer";
import NotificationModal from 'components/NotificationModal';
import LLMSelectModal from 'components/Modal/LLMSelectModal';
import { setIsLLMModalOpen } from 'slices/app/reducer';


// Images
import logo from 'images/logo-bird.svg';
import historyIcon from 'images/history.svg';
import chatIcon from 'images/chat-alt.svg';
import uploadIcon from 'images/upload-icon.svg';
import dashboardIcon from 'images/dashboard.svg';
import alertIcon from 'images/alert.svg';
import collaborativeIdeaIcon from "images/collabrate-trio-circle-icon-2.svg";
import newChatIcon from "images/pen-new-square-icon.svg";
import bellIcon from "../../images/bell.svg"
import { resetChats } from 'slices/chat/reducer';
import { useAuth } from 'context/AuthContext';
import clsx from 'clsx';
import { getAvatarBGColor } from 'utils/helper';
import { setSelectedDashboard } from 'slices/dashboard/reducer';
import openaiLogo from 'images/llms/openai.jpg';
import anthropicLogo from 'images/llms/anthropic.jpg';
import mistralLogo from 'images/llms/mistral.jpg';
import geminiLogo from 'images/llms/gemini.jpg';

const LLM_LOGOS = {
    Openai: openaiLogo,
    anthropic: anthropicLogo,
    mistral: mistralLogo,
    Gemini: geminiLogo,
    openai: openaiLogo,
    gemini: geminiLogo,
    Mistral: mistralLogo,
    Anthropic: anthropicLogo
};

const HeaderAlt = ({ hasDashboardFilter = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isVfeNew = typeof window !== 'undefined' && window.location.href.includes('vfenw');
    const dispatch = useDispatch();

    const { logout, user } = useAuth();
    const { newNotificationCount } = useSelector((state) => state.ChatReducer);
    const { selectedLLM } = useSelector((state) => state.AppReducer);

    const isActive = (path) => {
        if (path === "/analyze-doc" && location.pathname.startsWith("/analyze-doc/")) {
            return "bg-[#7357eb]";
        }
        return location.pathname === path ? 'bg-[#7357eb]' : ''
    };

    const startNewChat = () => {
        dispatch(resetChats([]));
        navigate('/chat')
    }

    const goToDashboard = () => {

        if (location.pathname !== "/dashboard") {
            const allDashboards = {
                label: "All dashboards",
                value: null,
                id: null,
            }
            dispatch(setSelectedDashboard(allDashboards));
            navigate('/dashboard');
        }
    }

    const goToCustomDashboard = () => {

        if (location.pathname !== "/dashboard-new") {
            const allDashboards = {
                label: "All dashboards",
                value: null,
                id: null,
            }
            dispatch(setSelectedDashboard(allDashboards));
            navigate('/dashboard-new');
        }
    }

    const handleCloseModal = () => {
        dispatch(setIsNotificationModalOpen(false));
    };

    const handleOpenModal = () => {
        dispatch(setIsNotificationModalOpen(true));
    }


    return (
        <header className="flex items-center justify-between p-4 header-border-margin">
            <div className="flex items-center pr-2">
                <img src={logo} alt="Logo" className="h-9 mr-4" />
                <nav className={`before:content-[''] before:border-l before:h-6 before:pr-3 before:border-left border-header-custom-before flex items-center space-x-4 ${isVfeNew ? 'space-x-2' : 'space-x-4'}`}>

                    {
                        location.pathname.startsWith("/chat") && (
                            <button
                                title="start new chat"
                                onClick={startNewChat}
                                className={`bg-[#69738a] hover:bg-[#7357eb] text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
                            >
                                <img src={newChatIcon} alt="Start new chat" className="h-5 w-5" />
                            </button>
                        )
                    }

                    <button
                        onClick={() => navigate('/chat')}
                        className={`${isActive('/chat')} hover:bg-[#7357eb] text-sm text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
                    >
                        <img src={chatIcon} alt="Chat Icon" className="h-4 w-4 mr-2" />
                        Chat
                    </button>
                    {/* <button
						onClick={() => navigate('/analyze-doc')}
						className={`${isActive('/analyze-doc')} hover:bg-[#7357eb] text-sm text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
					>
						<img src={uploadIcon} alt="Upload File Icon" className="h-4 w-4 mr-2" />
						Analyze a Doc
					</button> */}
                    <button
                        onClick={goToDashboard}
                        className={`${isActive('/dashboard')} ${isVfeNew ? 'w-[140px]' : ''} hover:bg-[#7357eb] text-sm text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
                    >
                        <img src={dashboardIcon} alt="Dashboard Icon" className="h-4 w-4 mr-2" />
                        Dashboard
                    </button>
                    {window.location.href.includes("vfenw") && (
                        <button
                            onClick={goToCustomDashboard}
                            className={`${isActive('/dashboard-new')} ${isVfeNew ? 'w-[120px]' : ''} hover:bg-[#7357eb] text-sm text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
                        >
                            <img src={dashboardIcon} alt="Dashboard Icon" className="h-4 w-4 mr-2" />
                            Custom
                        </button>)}
                    <button
                        onClick={() => navigate('/collaborative-forum')}
                        className={`${isActive('/collaborative-forum')} ${isVfeNew ? 'w-[110px]' : ''} hover:bg-[#7357eb] text-sm text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
                    >
                        <img src={collaborativeIdeaIcon} alt="Threads" className="h-[14px] w-[14px] mr-2 opacity-80" />
                        Threads
                    </button>
                    <button
                        onClick={() => navigate('/alerts')}
                        className={`${isActive('/alerts')} hover:bg-[#7357eb] ${isVfeNew ? 'w-[100px]' : ''} text-sm text-white py-2 px-2.5 rounded-xl border-header-custom flex items-center transition-transform duration-200 ease-in-out transform hover:scale-105`}
                    >
                        <img src={alertIcon} alt="Alerts Icon" className="h-4 w-4 mr-2" />
                        Alerts
                    </button>

                    {/* <div className={`${isVfeNew ? 'w-[250px]' : ''}`}> */}
                    <RoleSelect />
                    {/* </div> */}
                </nav>
            </div>
            <div className="flex items-center gap-x-4">

                {/* LLM Modal Select Button */}
                <button
                    onClick={() => dispatch(setIsLLMModalOpen(true))}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg border border-[#232B3A] bg-[#1E293B] hover:bg-violet-800 transition text-white min-w-[140px]`}
                >
                    {selectedLLM ? (
                        <>
                            <img
                                src={LLM_LOGOS[selectedLLM.value]}
                                alt={selectedLLM.label}
                                className="h-6 w-6 rounded-full mr-2"
                            />
                            <span className="font-medium text-base">{selectedLLM.label}</span>
                        </>
                    ) : (
                        <>
                            <svg className="h-5 w-5 text-violet-300 mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" /><path d="M8 12h8M12 8v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
                            <span className="font-medium text-base">Select LLM</span>
                        </>
                    )}
                </button>
                {/* DashBoard Filter */}
                {
                    hasDashboardFilter && <DashBoardSelect />
                }

                {/* Add Chat Icon */}
                {/* <button className="bg-[#F283B6] text-white py-1.5 px-2 border-header-custom rounded-xl transition-transform duration-200 ease-in-out transform hover:scale-105">
          <img src={plusIcon} alt="Profile" className="h-8 w-8 rounded-full p-1" />
        </button> */}

                {/* History Icon */}
                <button onClick={() => navigate('/history')} className={`${isActive('/history')} text-white py-1.5 px-2 rounded-full border-header-custom rounded-xl transition-transform duration-200 ease-in-out transform hover:scale-105`}>
                    <img src={historyIcon} alt="Profile" className="h-8 w-8 rounded-full p-1" />
                </button>

                {/* Notification Icon */}
                <div className="relative">
                    <button
                        onClick={() => { handleOpenModal() }}
                        className=" rounded-full p-1 relative text-black transition-transform duration-200 ease-in-out transform hover:scale-105">
                        {newNotificationCount !== undefined && newNotificationCount !== null && (
                            <span className="absolute top-0 right-0 bg-[#F283B6] rounded-full h-4 w-4 flex items-center justify-center text-xs text-white">
                                {newNotificationCount > 0 ? newNotificationCount : '0'}
                            </span>
                        )}

                        <img src={bellIcon} alt="Profile" className="h-8 w-8 rounded-full" />
                    </button>
                </div>

                {/* Profile Icon */}
                <Menu
                    arrow={true}
                    position={"anchor"}
                    gap={12}
                    align={"end"}
                    menuClassName={`z-10 min-w-[10rem] bg-primary p-2 rounded shadow-primary-1`}
                    menuButton={
                        <button title={`Profile`} className={clsx('h-10 w-10 flex items-center justify-center rounded-full transition-transform duration-200 ease-in-out transform hover:scale-105', getAvatarBGColor(user?.id || "User"))}>
                            {
                                user?.profilePicUrl ? (
                                    <img src={user.profilePicUrl} alt="Profile" className="cursor-pointer h-10 w-10 rounded-full" />
                                ) : (
                                    <span className="text-black">{user?.firstName?.[0]?.toUpperCase() || "U"}</span>
                                )
                            }
                        </button>
                    }
                >

                    <MenuItem
                        onClick={() => navigate('/manage-credentials')}
                        className={`cursor-pointer m-0 p-2 text-white text-sm text-nowrap hover:bg-primary-3 hover:font-medium`}
                    >
                        Manage Credentials
                    </MenuItem>

                    <MenuItem
                        onClick={() => navigate('/change-password')}
                        className={`cursor-pointer m-0 p-2 text-white text-sm text-nowrap hover:bg-primary-3 hover:font-medium`}
                    >
                        Change Password
                    </MenuItem>

                    <MenuDivider />

                    <MenuItem
                        onClick={logout}
                        className={`cursor-pointer m-0 p-2 text-white text-sm text-nowrap hover:bg-primary-3 hover:font-medium`}
                    >
                        Logout
                    </MenuItem>
                </Menu>

            </div>
            <NotificationModal onClose={handleCloseModal} />
            <LLMSelectModal />
        </header>

    );
};

export default HeaderAlt;
